import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
    Card,
    Typography,
    List,
    ListItem,
    ListItemPrefix,
    Alert,
} from "@material-tailwind/react";
import DashboardIcon from '@mui/icons-material/Dashboard';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import {
    PowerIcon,
} from "@heroicons/react/24/solid";
import Swal from "sweetalert2";




export default function SideBarGPT() {
    const [openAlert, setOpenAlert] = useState(true);
    const [ifMobile, setIfMobile] = useState(false);

    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const handleSidebarToggle = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // create a hook to detect if the screen is mobile or not

    useEffect(() => {
        if (window.innerWidth < 722) {
            setIfMobile(true);
            setIsSidebarOpen(false);
        }
        else {
            setIfMobile(false);
            setIsSidebarOpen(true);
        }
        window.addEventListener("resize", () => {
            if (window.innerWidth < 722) {
                setIfMobile(true);
                setIsSidebarOpen(false);
            }
            else {
                setIfMobile(false);
                setIsSidebarOpen(true);
            }
        });
    }, []);


    const navigate = useNavigate();

    return (
        <div className="">
            {ifMobile ? (
                <div className="fixed top-4 z-50 justify-between items-center">
                    <button
                        className="focus:outline-none"
                        onClick={
                            () => {
                                handleSidebarToggle()
                            }
                        }
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-8 w-8 text-black"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            {isSidebarOpen ? (
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={3}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            ) : (
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={3}
                                    d="M4 6h16M4 12h8m-8 6h16"
                                />
                            )}
                        </svg>
                    </button>
                </div>
            ) : (
                ""
            )}

            <Card
                className={`top-4 left-4 ActualSideBar h-[calc(100vh-2rem)] w-full max-w-[18rem] p-4 shadow-xl  shadow-blue-gray-200 sidebar ${isSidebarOpen ? "openAnimation" : "closeAnimation"}`}>


                <div className="mb-2 p-4">
                    <Typography variant="h5" color="blue-gray">
                        <img src={require(`../../assets/MainLogo.webp`)} className="h-24 border-2 border-blue-gray-50 p-1" />
                    </Typography>
                </div>
                <List>
                    <hr className="my-2 border-blue-gray-50" />
                    <ListItem onClick={() => {

                        (ifMobile) ? setIsSidebarOpen(false) : setIsSidebarOpen(true);
                        navigate('/');

                    }}>
                        <ListItemPrefix>
                            <DashboardIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        DashBoard
                    </ListItem>



                    <ListItem
                        onClick={() => {
                            (ifMobile) ? setIsSidebarOpen(false) : setIsSidebarOpen(true);
                            navigate('/NewTests');

                        }}
                    >
                        <ListItemPrefix>
                            <RecentActorsIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        Tests
                    </ListItem>



                    <ListItem
                        className="border-b-4 border-blue-gray-50"
                        onClick={() => {
                            (ifMobile) ? setIsSidebarOpen(false) : setIsSidebarOpen(true);
                            navigate('/MyTests');
                        }}
                    >
                        <ListItemPrefix>
                            <ReceiptLongIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        My Test Attempts
                    </ListItem>

                    <ListItem onClick={() => {
                        Swal.fire({
                            title: 'Are you sure?',
                            text: "You will be logged out!",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Log Out'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                Cookies.remove("user");
                                navigate('/login');
                            }
                        }
                        )

                    }}

                    >
                        <ListItemPrefix>
                            <PowerIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        Log Out
                    </ListItem>
                </List>
                <Alert open={openAlert} className="mt-auto bg-bgBlueDark" onClose={() => setOpenAlert(false)}>
                    <img src={require(`../../assets/logoImg.jpg`)} className="w-16 h-16 rounded-full border-2 border-blue-gray-50 p-1" />
                    <Typography variant="h6" className="mb-1">
                        Something Exciting
                    </Typography>
                    <Typography variant="small" className="font-normal opacity-80">
                       US Academy,
                        <br />
                        Testing Portal Services
                    </Typography>
                    <div className="mt-4 flex gap-3">
                        <Typography
                            variant="small"
                            className="font-medium opacity-80 cursor-pointer"
                            onClick={() => { setOpenAlert(false) }}
                        >
                            Dismiss
                        </Typography>
                        <Typography as="div" variant="small" className="font-medium">
                            Visit Now
                        </Typography>
                    </div>
                </Alert>
            </Card>
        </div>
    );
}